import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  onClose: () => void;
  sort: string;
  setSort: (sort: string) => void;
}

const sortOptions = [
  { label: '예상입찰가 낮은순', value: 'AA' },
  { label: '예상입찰가 높은순', value: 'AD' },

  { label: '예상매각가 낮은순', value: 'BA' },
  { label: '예상매각가 높은순', value: 'BD' },

  { label: '매매차익 낮은순', value: 'CA' },
  { label: '매매차익 높은순', value: 'CD' },

  { label: '유찰횟수 적은순', value: 'DA' },
  { label: '유찰횟수 많은순', value: 'DD' },

  { label: 'ROI 낮은순', value: 'EA' },
  { label: 'ROI 높은순', value: 'ED' },

  { label: 'ROE 낮은순', value: 'FA' },
  { label: 'ROE 높은순', value: 'FD' },
];

function SortOptionModal({ onClose, sort, setSort }: Props) {
  const [now, setNow] = useState(sort);
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <Spacer />
          <Title>정렬</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </Header>
        <Container>
          {sortOptions.map((item) => (
            <ListItem key={item.value} onClick={() => setNow(item.value)}>
              <ListLabel $selected={now === item.value}>{item.label}</ListLabel>
              {now === item.value && (
                <img src="/assets/images/check/blue_check_24.svg" alt="check" />
              )}
            </ListItem>
          ))}
        </Container>
        <Bottom>
          <CancleButton
            onClick={() => {
              setNow(sort);
              onClose();
            }}
          >
            취소
          </CancleButton>
          <ConfirmButton
            onClick={() => {
              setSort(now);
              onClose();
            }}
          >
            적용
          </ConfirmButton>
        </Bottom>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default SortOptionModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* max-height: 640px; */
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  border-radius: 16px 16px 0 0;
  border: 1px solid #e1e2e4;
  box-shadow:
    0 2px 8px 0 rgba(0, 0, 0, 0.12),
    0 1px 4px 0 rgba(0, 0, 0, 0.08),
    0 0 1px 0 rgba(0, 0, 0, 0.08);
`;

const Header = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;

const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  color: #222;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const ListItem = styled.div`
  display: flex;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const ListLabel = styled.div<{ $selected?: boolean }>`
  flex: 1 0 0;
  color: ${({ $selected }) => ($selected ? '#008AFF' : '#616161')};
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  justify-content: center;
  gap: 16px;
  border-top: 1px solid
    var(--semantic-line-normal-nomal, rgba(112, 115, 124, 0.22));
  background: #fff;
`;

const Button = styled.button`
  outline: none;
  border: none;
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const CancleButton = styled(Button)`
  background: var(--component-fill-normal, rgba(112, 115, 124, 0.08));
  color: var(--semantic-label-neutral, #616161);
`;

const ConfirmButton = styled(Button)`
  flex: 1 0 0;
  background: var(--semantic-primary-nomal, #008aff);

  color: var(--semantic-static-white, #fff);
  font-weight: 700;
`;
